import React, { useState, useEffect, Suspense, lazy } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import ScrollToTop from "./components/ScrollToTop"; // ✅ ScrollToTop eingebaut
import Footer from "./components/Footer";
import Loader from "./components/Loader";
import "./styles/App.css";

// 🔹 Lazy Load für weniger kritische Komponenten (Performance-Boost)
const Hero = lazy(() => import("./components/Hero"));
const About = lazy(() => import("./components/About"));
const Projects = lazy(() => import("./components/Projects"));
const ProjectDetail = lazy(() => import("./pages/ProjectDetail"));
const Contact = lazy(() => import("./components/Contact"));
const Datenschutz = lazy(() => import("./pages/Datenschutz"));
const Impressum = lazy(() => import("./pages/Impressum"));

const App = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // 🔹 Navbar & Footer ausblenden auf /datenschutz, /project/:id und /impressum
  const hideNavAndFooter =
    location.pathname.startsWith("/project/") ||
    location.pathname === "/datenschutz" ||
    location.pathname === "/impressum";

  useEffect(() => {
    // 🔹 Loader nach 1 Sekunde statt 2 ausblenden (schnellere Interaktion)
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />; // Zeigt den Loader an, solange die Seite lädt
  }

  return (
    <div>
      <ScrollToTop /> {/* ✅ ScrollToTop bei Routenwechsel */}
      {!hideNavAndFooter && <Navbar />}

      <Suspense fallback={<Loader />}> {/* Lazy Loading für Komponenten */}
        <Routes>
          <Route path="/" element={
            <>
              <Hero />
              <About />
              <Projects />
              <Contact />
            </>
          } />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </Suspense>

      {!hideNavAndFooter && <Footer />}
    </div>
  );
};

export default App;
